import './aviatorevent/style';
import FormStructure from './aviatorevent/form_structure';

export default FormStructure;